import { render, staticRenderFns } from "./Main_whole.vue?vue&type=template&id=4cfd7e16&scoped=true&"
import script from "./Main_whole.vue?vue&type=script&lang=js&"
export * from "./Main_whole.vue?vue&type=script&lang=js&"
import style0 from "./Main_whole.vue?vue&type=style&index=0&id=4cfd7e16&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd7e16",
  null
  
)

export default component.exports